import { ColumnProps } from 'antd/lib/table';
import { DossierTableCellActions } from 'client/components/schema/procedures/table/DossierTableCellActions';
import { DossierTableCellTitle } from 'client/components/schema/procedures/table/DossierTableCellTitle';
import { RequestApi } from 'client/components/schema/requests/RequestApi';
import { IRequestDossierRecord } from 'common/dto/RequestDossierDto';
import { RequestResponseFileType } from 'common/schema/request/RequestResponseFileType';
import React from 'react';
import { ReadDocumentIcon } from '../document/ReadDocumentIcon';

export function getRequestDossierContentColumns(
  expandedRows: string[],
  id: number | null,
  isAdmin?: boolean
): ColumnProps<IRequestDossierRecord>[] {
  return [
    {
      title: 'Domanda',
      dataIndex: 'title',
      key: 'title',
      render: (_, record) => (
        <DossierTableCellTitle
          type={record.type}
          name={record.data.name}
          opened={expandedRows.includes(record.token)}
          document={record.data}
          readFlag={
            !isAdmin && record.type !== RequestResponseFileType.Dossier ? (
              <ReadDocumentIcon document={record.data} />
            ) : null
          }
          actionsMobile={
            <DossierTableCellActions
              to={RequestApi.links.documentDetail(isAdmin, id, record.token)}
              token={record.token}
              requestId={id}
              isFolder={record.type === RequestResponseFileType.Dossier}
              isAttachment={record.type === RequestResponseFileType.Attachment}
              mobileOnly
            />
          }
        />
      )
    },
    {
      title: 'Azioni',
      key: 'actions',
      responsive: ['sm'],
      width: 100,
      render: (_, record) => (
        <DossierTableCellActions
          to={RequestApi.links.documentDetail(isAdmin, id, record.token)}
          token={record.token}
          requestId={id}
          isFolder={record.type === RequestResponseFileType.Dossier}
          isAttachment={record.type === RequestResponseFileType.Attachment}
        />
      )
    }
  ];
}
